import { BonusCustomerCondition, BonusSettlementSupplierStatus } from '@synergy/models';
import { createSelector } from 'reselect';

import { AppState } from '../../../../store/models/app-state';

export const bonusSettlementsState = (state: AppState) => state.bonusSettlements;

export const bonusSettlementsSupplierDetailSelector = createSelector(bonusSettlementsState, state => {
    if (!state.supplierDetail.bonusSettlementSupplierDetail) {
        return null;
    }

    const bonusSettlementSupplierDetail = state.supplierDetail.bonusSettlementSupplierDetail;
    const readOnly =
        bonusSettlementSupplierDetail.status !== BonusSettlementSupplierStatus.Open &&
        bonusSettlementSupplierDetail.status !== BonusSettlementSupplierStatus.PartiallySent &&
        bonusSettlementSupplierDetail.status !== BonusSettlementSupplierStatus.Sent &&
        bonusSettlementSupplierDetail.status !== BonusSettlementSupplierStatus.AutomaticallySent;

    return {
        ...bonusSettlementSupplierDetail,
        bonusSettlementStatus: bonusSettlementSupplierDetail.bonusSettlementStatus,
        bonusConditions: bonusSettlementSupplierDetail.bonusConditions.map((condition: BonusCustomerCondition) => {
            const supplierPayout = condition.bonusCondition.supplierPayout;

            return {
                ...condition,
                bonusCondition: {
                    ...condition.bonusCondition,
                    supplierPayout:
                        supplierPayout !== undefined && supplierPayout !== null ? supplierPayout / 100 : undefined,
                    percentage: condition.bonusCondition.percentage
                        ? condition.bonusCondition.percentage / 100
                        : undefined,
                },
            };
        }),
        customerBonusSettlements: bonusSettlementSupplierDetail.customerBonusSettlements.map(settlement => ({
            ...settlement,
            customerBonusPayout:
                settlement.customerBonusPayout === undefined || settlement.customerBonusPayout === null
                    ? undefined
                    : settlement.customerBonusPayout / 100,
            payout: settlement.payout / 100,
            customerBonusBase: settlement.customerBonusBase / 100,
            bonusConditionValues: settlement.bonusConditionValues.map(condition => ({
                ...condition,
                value: condition.value === 0 ? null : condition.value,
            })),
            isVisible: true,
        })),
        noteFromSupplier: bonusSettlementSupplierDetail.noteFromSupplier,
        readOnly,

        bonusSettlementId: state.supplierOverview.details?.id,
        type: state.supplierOverview.details?.type,
    };
});
export const bonusSettlementsSupplierDetailRequestingSelector = createSelector(
    bonusSettlementsState,
    state => state.supplierDetail.requesting
);

export const bonusSettlementsSupplierDetailSubmittingSelector = createSelector(
    bonusSettlementsState,
    state => state.supplierDetail.isSubmitting
);
